module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-bottom.a43175df.svg";